import palette from 'theme/palette';
import overrides from 'theme/overrides';
import typography from 'theme/typography';
import { createTheme } from '@material-ui/core/styles'

const theme = createTheme({
  palette,
  typography,
  overrides,
  zIndex: {
    appBar: 1200,
    drawer: 1100
  }
});

export default theme;